module.exports = {
	"5fe6cc0473e0d313": "Error al iniciar sesión",
	"ff09e2c6d332d9a9": "Gerente de servicio posventa del distribuidor de mantenimiento",
	"e700c28686cf9239": "Gerente del servicio",
	"ac4b9e617b460217": "Propietario de la fuente",
	"cf9e55be6bc85b96": "Descripción breve",
	"2b68d9152e3d3db1": "Ministro de Defensa",
	"051d6d3c0467ce2c": "Compañía de ventas",
	"8d7d36bc6fb6d6ac": "Departamento de administración",
	"2c3949540a8af2b2": "Desarrollo web del Distrito Este",
	"5cabbc13e4bee21a": "Administrador",
	"42c4c030fab33ead": "Departamento de Mercado",
	"54f11cc55ea6122f": "Distribuidor de marca A",
	"d115f29ef6edb41f": "Departamento de ventas",
	"3417a5fcc3a35dec": "Subsector de ventas",
	"7bd27a06c47deebb": "Subsector de venta del distribuidor A",
	"465d732d68ebdfbb": "Operación exitosa",
	"d3ad9f48039d6f36": "Ingrese la contraseña que cumple las instrucciones",
	"9b9a980dcdf8e51a": "La longitud de la contraseña es de 10~16 dígitos, y debe contener al menos tres tipos de los siguientes: números, letras y caracteres (solo puede contener `~!@#$%^&*()_-).",
	"db2a83c04d0d85ee": "Uno",
	"c9e78713e31e5c0c": "Dos",
	"a0da04db4f9323b6": "Tres",
	"11071e8d339b611c": "Cuatro",
	"77c043016d325c68": "Cinco",
	"3d86ac98afd3c98b": "Seis",
	"ac2c5e612fb71dbb": "Día",
	"2a314654cf9d4b65": "Hace un rato",
	"400201ee4590ba25": "Hace minutos",
	"38dff0847f8b6b54": "Hace horas",
	"acc203985e88c8ff": "Hace un día",
	"9954ce6437e66f41": "Mes",
	"08dae0e0a7266acb": "Hora",
	"cdf97643b4d2b4ec": "minuto(s)",
	"9e8d6372f23ed0ae": "Todos los derechos reservados",
	"922c2d41bd36ae30": "Compruebe que la URL que ha introducido es correcta, haga clic en el botón de abajo para volver a la página de inicio o enviar un informe de errores",
	"8cd396b24d50bde9": "Volver a la página de inicio",
	"34655267df949d36": "La página que visitó no existe ...",
	"0c09f9f949502219": "Ingresar su nombre de miembro / número de teléfono / buzón",
	"e93cb6cc8d5978ed": "Ingrese la contraseña",
	"f787a49b96414843": "Seleccione el tipo de inicio de sesión",
	"29feb2a0dd8c64aa": "Distribuidor",
	"136c1cfccaefce89": "Fábrica de la máquina principal",
	"a16c753c0ce27b93": "Consumidor",
	"a787eaff540ed815": "Chirey International Intelligent Marketing Platform",
	"8efc7ede2b82d0d2": "Bienvenido a iniciar sesión",
	"b6bd35b4275ff215": "Inicio de sesión normal",
	"c7609e554782bec4": "Iniciar sesión",
	"5c839808c79ec750": "¿Olvidaste tu contraseña?",
	"4c04782973d13249": "Ingrese la contraseña correcta",
	"35a9eeeeed94b9c5": "Verificación de identidad",
	"1f899a083534373c": "Restablecer nueva contraseña",
	"25e03120b83ee4ed": "Finalizar",
	"3037d5200851358c": "Ingrese la nueva contraseña",
	"12486c6be40db3e7": "Ingrese la nueva contraseña de nuevo",
	"204ffab8a6e01870": "Aceptar",
	"cb5652273096ee32": "Volver a la página de inicio de sesión",
	"47a48843580a4a66": "Ingrese una contraseña en formato correcto",
	"9be71a11b46a4836": "Las contraseñas ingresadas dos veces no coinciden",
	"6f43ea859d9f785b": "La longitud de la contraseña es de 10~16 dígitos, y debe contener al menos tres tipos de los siguientes: números, letras y caracteres (solo puede contener `~!@#$%^&*()_-)",
	"5f572f4cad00da16": "Contraseña restablecida con éxito",
	"29799f539ee6b906": "Ingrese el número de teléfono",
	"f1ee1d97e869e447": "Ingrese el código de verificación",
	"03108ca21c7aae62": "Disponible de nuevo en {0} segundos",
	"7dca92c6a707efb7": "Obtener Código de verificación",
	"b0dd7bfe25cfcd7c": "Ingrese el número de teléfono correcto",
	"c54f71547450a65d": "El Código de verificación fue enviado con éxito a{0}",
	"ace46c7b30cb9a6e": "Obtener el código de verificación",
	"582eb6b01e3ddd0e": "Inicio de sesión de número de móvil",
	"2d394cf2150beea9": "Inicio de sesión de la cuenta",
	"e4e4d24449be2f3b": "Correo electrónico de inicio de sesión",
	"a4132369592eddf8": "Por favor ingrese su número de móvil",
	"7b04a69f42606895": "Por favor ingrese su número de cuenta",
	"616d3762556837aa": "Por favor ingrese su correo electrónico",
	"f6f6a306a8b4e68c": "Ingrese su número de móvil",
	"e78e5ae48541083f": "Ingrese su número de cuenta",
	"e1171e54815f0502": "Ingrese su correo electrónico",
	"9cd180bf2c9735b7": "Falló la transmisión del Código de verificación, compruebe el número de teléfono móvil."
};


//////////////////
// WEBPACK FOOTER
// ./locale/spa.js
// module id = qUMX
// module chunks = 8